import { isEqual } from 'lodash';
import deepOrderObj from '../../deepOrderObj';

const compareBlocks = (original: object, changes?: object) => {
  try {
    const stringifiedOriginal = JSON.stringify(deepOrderObj(original));
    const stringifiedChanges = JSON.stringify(deepOrderObj(changes));

    return stringifiedOriginal === stringifiedChanges;
  } catch {
    return isEqual(original, changes);
  }
};

export default compareBlocks;
